<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span>{{ number }}.1</span>
                {{ 'full-data.pbc.information-sent' | translate }}
            </h3>

            <div class="row">
                <div class="col-12 col-sm-6">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input
                            [name]="prefix + 'Name'"
                            matInput
                            [placeholder]="'form.name' | translate"
                            [disabled]="true"
                            [ngModel]="client.name"
                        />
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6" *ngIf="!client.isLegalPerson">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input
                            [name]="prefix + 'Surname'"
                            matInput
                            [placeholder]="'form.surname' | translate"
                            [disabled]="true"
                            [ngModel]="client.surname"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-4">
                    <ng-container [ngSwitch]="client.docType">
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.DNI">
                            <mat-label>{{ 'form.document-types.DN' | translate }}</mat-label>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.hints.dni' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIF">
                            <mat-label>{{ 'form.document-types.NF' | translate }}</mat-label>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.hints.nif' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.CIF">
                            <mat-label>{{ 'form.document-types.CI' | translate }}</mat-label>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.hints.cif' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE">
                            <mat-label>{{ 'form.document-types.NR' | translate }}</mat-label>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.hints.nie' | translate"
                                [disabled]="true"
                                [(ngModel)]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE_NOT_RESIDENT">
                            <mat-label>{{ 'form.document-types.NN' | translate }}</mat-label>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.hints.nie' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT">
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.document-types.PN' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT_LATIN">
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.document-types.PL' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PERMISSION">
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.document-types.PR' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT">
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.document-types.TR' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                        <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                            <input
                                [name]="prefix + 'Document'"
                                matInput
                                [placeholder]="'form.document-types.DI' | translate"
                                [disabled]="true"
                                [ngModel]="client.docId"
                            />
                        </mat-form-field>
                    </ng-container>
                </div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="!client.isSpanish">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <mat-select
                            [name]="prefix + 'Citizenship'"
                            [placeholder]="'form.citizenship' | translate"
                            [disabled]="true"
                            [ngModel]="client.citizenship"
                        >
                            <ng-template ngFor let-country [ngForOf]="countries">
                                <mat-option [value]="country.id.value">
                                    {{ country.name }}
                                </mat-option>
                            </ng-template>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    class="col-12 col-sm-6 col-lg-4"
                    *ngIf="[DocumentType.PASSPORT, DocumentType.PASSPORT_LATIN].indexOf(client.docType) !== -1"
                >
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <mat-select
                            [name]="prefix + 'CountryOfResidence'"
                            [placeholder]="'form.country-of-residence' | translate"
                            [disabled]="true"
                            [ngModel]="client.countryOfResidence"
                        >
                            <ng-template ngFor let-country [ngForOf]="countries">
                                <mat-option [value]="country.id.value">
                                    {{ country.name }}
                                </mat-option>
                            </ng-template>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-lg-4" *ngIf="!!client.birthDate">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                        <input
                            [name]="prefix + 'BirthDate'"
                            matInput
                            [placeholder]="'form.birth-date' | translate"
                            [disabled]="true"
                            [value]="client.birthDate?.toDate() | date: 'dd-MM-yyyy'"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-8">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input
                            [name]="prefix + 'Type'"
                            matInput
                            [placeholder]="'form.natural-legal-person' | translate"
                            [disabled]="true"
                            [value]="(client.isLegalPerson ? 'form.legal-female' : 'form.natural-female') | translate"
                        />
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-4">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input
                            [name]="prefix + 'Status'"
                            matInput
                            [placeholder]="'form.status' | translate"
                            [disabled]="true"
                            [value]="
                                (client.isRejected()
                                    ? 'full-data.pbc.statuses.rejected'
                                    : client.pbc.detection
                                    ? 'full-data.pbc.statuses.pending'
                                    : 'full-data.pbc.statuses.accepted'
                                ) | translate
                            "
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span>{{ number }}.2</span>
                {{ 'full-data.pbc.information-received' | translate }}
            </h3>
            <p class="mat-caption font-italic mb-3 mb-sm-4">
                <mat-hint>{{ 'full-data.pbc.help-received' | translate }}</mat-hint>
            </p>
            <div class="row" *ngIf="client.pbc && client.pbc.detection">
                <div class="col-12">
                    <div class="header d-flex mb-1">
                        <div class="flex-shrink-1 flex-grow-1">
                            <span>{{ 'form.name-and-surname' | translate }}</span>
                        </div>
                        <div class="d-none d-sm-block" style="width: 160px">
                            <span>{{ 'form.identity-document' | translate }}</span>
                        </div>
                        <div class="d-none d-lg-block" style="width: 60px">
                            <span>{{ 'form.country' | translate }}</span>
                        </div>
                        <div class="d-none d-md-block" style="width: 110px">
                            <span>{{ 'form.prp-category' | translate }}</span>
                        </div>
                        <div class="d-none d-md-block" style="width: 80px">
                            <span>{{ 'form.prp-type' | translate }}</span>
                        </div>
                        <div class="d-none d-md-block" style="width: 90px">
                            <span>{{ 'form.received-date' | translate }}</span>
                        </div>
                    </div>

                    <mat-accordion class="pbc" [displayMode]="'flat'">
                        <mat-expansion-panel
                            class="mat-elevation-z0"
                            (afterCollapse)="onResize()"
                            (afterExpand)="onResize()"
                            *ngFor="let detection of client.pbc.detections"
                        >
                            <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
                                <mat-panel-title>
                                    <div class="flex-shrink-1 flex-grow-1">
                                        <span class="mat-subheading-1">{{ detection.fullName }}</span>
                                    </div>
                                    <div class="d-none d-sm-block" style="width: 160px">
                                        <span class="mat-subheading-1">{{ detection.document?.number || '-' }}</span>
                                    </div>
                                    <div class="d-none d-lg-block" style="width: 60px">
                                        <span class="mat-subheading-1">{{ detection.address?.country || '-' }}</span>
                                    </div>
                                    <div class="d-none d-md-block" style="width: 110px">
                                        <span class="mat-subheading-1">{{ detection.prpCategory || '-' }}</span>
                                    </div>
                                    <div class="d-none d-md-block" style="width: 80px">
                                        <span class="mat-subheading-1">{{ detection.prpType || '-' }}</span>
                                    </div>
                                    <div class="d-none d-md-block" style="width: 90px">
                                        <span class="mat-subheading-1">{{
                                            detection.updatedAt ? (detection.updatedAt.toDate() | date: 'dd-MM-yyyy') : '-'
                                        }}</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="bg-white pt-3 px-3 pb-2">
                                <strong class="text-blue">{{ 'form.detection' | translate }}: </strong>
                                <span>{{ client.pbc.detection || '-' }}</span
                                ><br /><br />
                                <strong class="text-blue">{{ 'form.dossier' | translate }}: </strong>
                                <span>{{ client.pbc.dossier || '-' }}</span
                                ><br /><br />
                                <strong class="text-blue">{{ 'form.date' | translate }}: </strong>
                                <span>{{ client.pbc.date?.toDate() | date: 'dd-MM-yyyy HH:mm:ss' || '-' }}</span
                                ><br /><br />
                                <h4 class="text-blue">{{ 'form.detections' | translate }}:</h4>
                                <div class="ml-0 ml-md-2">
                                    <h4 class="text-blue">
                                        {{ 'full-data.pbc.addresses' | translate }}
                                    </h4>
                                    <div class="row">
                                        <div class="col-12 col-md-6 col-lg-4" *ngFor="let address of detection.addresses">
                                            <p class="pl-3 pl-md-0">
                                                <strong>{{ 'form.address' | translate }}:</strong>&nbsp;<span>{{
                                                    address.street || '-'
                                                }}</span
                                                ><br />
                                                <strong>{{ 'form.city' | translate }}:</strong>&nbsp;<span>{{ address.city || '-' }}</span
                                                ><br />
                                                <strong>{{ 'form.country' | translate }}:</strong>&nbsp;<span>{{
                                                    address.country || '-'
                                                }}</span
                                                ><br />
                                                <strong>{{ 'form.comment' | translate }}:</strong>&nbsp;<span>{{
                                                    address.comment || '-'
                                                }}</span>
                                            </p>
                                        </div>
                                    </div>

                                    <h4 class="text-blue">
                                        {{ 'full-data.pbc.aliases' | translate }}
                                    </h4>
                                    <div class="row">
                                        <div class="col-12 col-md-6 col-lg-4" *ngFor="let alias of detection.aliases">
                                            <p class="pl-3 pl-md-0">
                                                <strong>{{ 'form.name' | translate }}:</strong>&nbsp;<span>{{ alias.name || '-' }}</span
                                                ><br />
                                                <strong>{{ 'form.type' | translate }}:</strong>&nbsp;<span>{{ alias.type || '-' }}</span
                                                ><br />
                                                <strong>{{ 'form.comment' | translate }}:</strong>&nbsp;<span>{{
                                                    alias.comment || '-'
                                                }}</span>
                                            </p>
                                        </div>
                                    </div>

                                    <h4 class="text-blue">
                                        {{ 'full-data.pbc.birth-dates' | translate }}
                                    </h4>
                                    <div class="row">
                                        <div class="col-12 col-md-6 col-lg-4" *ngFor="let birthDate of detection.birthDates">
                                            <p class="pl-3 pl-md-0">
                                                <strong>{{ 'form.date' | translate }}:</strong>&nbsp;<span>{{
                                                    birthDate.date ? (birthDate.date.toDate() | date: 'dd-MM-yyyy') : '-'
                                                }}</span
                                                ><br />
                                                <strong>{{ 'form.country' | translate }}:</strong>&nbsp;<span>{{
                                                    birthDate.country || '-'
                                                }}</span
                                                ><br />
                                                <strong>{{ 'form.comment' | translate }}:</strong>&nbsp;<span>{{
                                                    birthDate.comment || '-'
                                                }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="client.hasShareHolders">
        <div class="row ml-lg-0" *ngFor="let shareHolder of client.shareHolders; index as i">
            <div class="col-12 mt-4">
                <table class="table participants">
                    <tbody>
                        <tr>
                            <td>
                                <i class="icon-legal text-blue" *ngIf="shareHolder.isLegalPerson"></i>
                                <i class="icon-natural-plus text-blue" *ngIf="!shareHolder.isLegalPerson"></i>
                            </td>
                            <td>
                                <strong *ngIf="shareHolder.isLegalPerson"
                                    >{{ 'form.name-shareholder-legal-of' | translate }} {{ client.fullName }}</strong
                                >
                                <strong *ngIf="!shareHolder.isLegalPerson"
                                    >{{ 'form.name-shareholder-natural-of' | translate }} {{ client.fullName }}</strong
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 mt-4">
                <thr-full-data-seven-admin-pbc [client]="shareHolder" [number]="resolveNumber(i)"></thr-full-data-seven-admin-pbc>
            </div>
        </div>
    </ng-container>
</ng-container>
